import { PaginatedResponse } from '@synergy/api';
import { createReducer } from '@reduxjs/toolkit';

import { AccountListItemDto } from '../models/dto/account-list-item-dto';
import { SupplierDetailDto } from '../models/dto/supplier-detail-dto';
import { SupplierMeta } from '../models/supplier-meta';
import { SupplierSpecialOfferDto } from '../models/dto/supplier-special-offer-dto';
import {
    supplierDetailReceived,
    supplierDetailReset,
    supplierDirectoryReceived,
    supplierDirectoryReset,
    supplierSpecialOffersReceived,
} from './supplier-actions';

export interface SupplierState {
    specialOffers: PaginatedResponse<SupplierSpecialOfferDto>;
    suppliers: PaginatedResponse<AccountListItemDto, SupplierMeta>;
    detail?: SupplierDetailDto;
}

const initialState: SupplierState = {
    specialOffers: { items: [], limit: 0, page: 1, total: 0, pages: 0 },
    suppliers: { items: [], limit: 0, page: 1, total: 0, pages: 0 },
};

export const supplierReducer = createReducer(initialState, builder => {
    builder.addCase(supplierSpecialOffersReceived, (state, action) => ({
        ...state,
        specialOffers: {
            ...action.payload,
            items:
                action.payload.page === 1
                    ? action.payload.items
                    : [...state.specialOffers.items, ...action.payload.items],
        },
    }));
    builder.addCase(supplierDirectoryReceived, (state, action) => {
        if (action.payload.page === 1) {
            return {
                ...state,
                suppliers: action.payload,
            };
        }

        return {
            ...state,
            suppliers: {
                ...state.suppliers,
                ...action.payload,
                items: [...state.suppliers.items, ...action.payload.items],
                meta: action.payload.meta,
            },
        };
    });
    builder.addCase(supplierDirectoryReset, state => ({
        ...state,
        suppliers: { items: [], limit: 0, page: 1, total: 0, pages: 0 },
    }));
    builder.addCase(supplierDetailReceived, (state, action) => ({
        ...state,
        detail: action.payload,
    }));
    builder.addCase(supplierDetailReset, state => ({
        ...state,
        detail: initialState.detail,
    }));
});
